// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/dist/vuetify.min.css
// module id = 240
// module chunks = 1